// Turn an uploaded image File into a small square data URL for storage. We
// downscale to a 128px cover-cropped square and re-encode, so a multi-MB photo
// becomes a few KB — IndexedDB stays lean and the avatar loads instantly.

const SIZE = 128

export async function fileToAvatarDataUrl(file: File): Promise<string> {
  const bitmap = await loadBitmap(file)
  const canvas = document.createElement('canvas')
  canvas.width = SIZE
  canvas.height = SIZE
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Canvas unsupported')

  // Cover-crop: scale so the shorter side fills, centre the overflow.
  const scale = Math.max(SIZE / bitmap.width, SIZE / bitmap.height)
  const w = bitmap.width * scale
  const h = bitmap.height * scale
  ctx.drawImage(bitmap, (SIZE - w) / 2, (SIZE - h) / 2, w, h)
  if ('close' in bitmap) bitmap.close()

  return canvas.toDataURL('image/webp', 0.85)
}

async function loadBitmap(file: File): Promise<ImageBitmap | HTMLImageElement> {
  if (typeof createImageBitmap === 'function') {
    return createImageBitmap(file)
  }
  // Fallback for browsers without createImageBitmap.
  const url = URL.createObjectURL(file)
  try {
    const img = new Image()
    await new Promise<void>((resolve, reject) => {
      img.onload = () => resolve()
      img.onerror = () => reject(new Error('Image load failed'))
      img.src = url
    })
    return img
  } finally {
    URL.revokeObjectURL(url)
  }
}
